var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.checkWidth() + ' ' + 'container'},[(_vm.loading)?[_c('div',{staticClass:"container vertical-center"},[_c('LoadingMDL')],1)]:[_c('CRow',[_c('CCol',{attrs:{"col":"12"}},[_c('CardConver',{attrs:{"content":_vm.content,"checkWidth":_vm.widthScreen},on:{"nextRoute":_vm.nextRoute}})],1)],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }